/* =========================================================
   monoc-site.js — ブランドサイト側に貼るだけで動く site.json 読み込み
   schema: monoc.site/v1   仕様: SITE-INTEGRATION.md
   ---------------------------------------------------------
   依存なし・素のJS。<script src="/js/monoc-site.js"></script> で読み込めます。

     MonocSite.load("/site.json").then(function (site) {
       site.items().forEach(renderCard);
       site.featured().forEach(renderPickup);
       site.popular().forEach(renderRankRow);
       site.applyRobots();
     });
   ========================================================= */
(function (global) {
  "use strict";

  var CACHE_KEY = "monoc_site_cache_v1";
  var DEFAULT_TTL = 10 * 60 * 1000;   // 10分

  // 一覧から外す availability（SITE-INTEGRATION.md §3.3）
  var HIDDEN = ["discontinued", "unavailable"];

  function readCache(url) {
    try {
      var all = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
      return all[url] || null;
    } catch (e) { return null; }
  }
  function writeCache(url, data) {
    try {
      var all = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
      all[url] = { at: Date.now(), data: data };
      localStorage.setItem(CACHE_KEY, JSON.stringify(all));
    } catch (e) { /* 保存できなくても動作は継続します */ }
  }

  function validate(json) {
    if (!json || typeof json !== "object") throw new Error("site.json が空です");
    if (String(json.schema || "").indexOf("monoc.site/") !== 0) {
      throw new Error("未知のスキーマです: " + json.schema);
    }
    if (!json.site) throw new Error("site.json に site がありません");
    if (!Array.isArray(json.items)) json.items = [];
    if (!json.ranking || !Array.isArray(json.ranking.items)) json.ranking = { items: [] };
    return json;
  }

  function wrap(json, meta) {
    var data = json;

    function visible() {
      return data.items
        .filter(function (i) { return HIDDEN.indexOf(i.availability) < 0; })
        .slice()
        .sort(function (a, b) {
          var pa = a.position == null ? 9999 : a.position;
          var pb = b.position == null ? 9999 : b.position;
          return pa - pb;
        });
    }

    return {
      /** 生のJSON。未知のフィールドを見たいときだけ使ってください */
      raw: data,
      /** 読み込み元の情報 { source: "network"|"cache"|"fallback", url, age } */
      loadedFrom: meta,

      /** 掲載商品（position昇順・販売終了と不整合は除外） */
      items: visible,

      /** 注目枠 */
      featured: function () {
        return visible().filter(function (i) { return i.featured === true; });
      },

      /** 人気順（ranking順・掲載中のものだけ） */
      popular: function () {
        var bySku = {};
        visible().forEach(function (i) { bySku[i.sku] = i; });
        return data.ranking.items
          .slice()
          .sort(function (a, b) { return (a.rank || 999) - (b.rank || 999); })
          .map(function (r) { return bySku[r.sku]; })
          .filter(Boolean);
      },

      /** SKUで1件取得 */
      bySku: function (sku) {
        var hit = data.items.filter(function (i) { return i.sku === sku; })[0];
        return hit || null;
      },

      /** 公開中か */
      isLive: function () { return data.site.status === "live"; },

      /** live 以外なら noindex を入れます */
      applyRobots: function () {
        if (this.isLive()) return false;
        var m = document.querySelector('meta[name="robots"]');
        if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
        m.content = "noindex, nofollow";
        return true;
      },

      /** 表示用のメタ情報 */
      meta: function () {
        return {
          generatedAt: data.generatedAt,
          brand: data.site.brand,
          brandName: data.site.brandName,
          siteName: data.site.name,
          kind: data.site.kind,
          status: data.site.status,
          itemsPolicy: data.site.itemsPolicy
        };
      }
    };
  }

  var MonocSite = {
    HIDDEN: HIDDEN,

    /**
     * site.json を読み込みます。
     * @param {string} url      site.json の場所（同梱なら "/site.json"）
     * @param {object} options  { ttl: ミリ秒, fallback: 同梱の初期データ(object) }
     * @returns {Promise} 上の wrap() が返すオブジェクト
     *
     * 取得に失敗しても reject しません。キャッシュ → fallback → 空データ の順で復帰します。
     * （サイトを落とさないことを最優先にしています）
     */
    load: function (url, options) {
      options = options || {};
      var ttl = options.ttl == null ? DEFAULT_TTL : options.ttl;
      var cached = readCache(url);

      // キャッシュが新しければネットワークを待たずに返します
      if (cached && Date.now() - cached.at < ttl) {
        try {
          return Promise.resolve(wrap(validate(cached.data), { source: "cache", url: url, age: Date.now() - cached.at }));
        } catch (e) { /* 壊れていたら取得しにいきます */ }
      }

      return fetch(url, { cache: "no-cache" })
        .then(function (res) {
          if (!res.ok) throw new Error("site.json HTTP " + res.status);
          return res.json();
        })
        .then(function (json) {
          var v = validate(json);
          writeCache(url, v);
          return wrap(v, { source: "network", url: url, age: 0 });
        })
        .catch(function (err) {
          if (global.console) console.warn("[MonocSite] site.json を取得できませんでした:", err.message);
          if (cached) {
            try { return wrap(validate(cached.data), { source: "cache", url: url, age: Date.now() - cached.at }); }
            catch (e) { /* 続けてフォールバックへ */ }
          }
          if (options.fallback) {
            try { return wrap(validate(options.fallback), { source: "fallback", url: url, age: null }); }
            catch (e) { /* 続けて空データへ */ }
          }
          return wrap({
            schema: "monoc.site/v1",
            site: { brand: "", brandName: "", name: "", kind: "ec", status: "draft", itemsPolicy: "manual" },
            items: [], ranking: { items: [] }
          }, { source: "empty", url: url, age: null });
        });
    }
  };

  global.MonocSite = MonocSite;
  if (typeof module !== "undefined" && module.exports) module.exports = MonocSite;
})(typeof window !== "undefined" ? window : globalThis);
